import "./Gallery.scss";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { Skeleton, useMediaQuery, useTheme } from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import GalleryService from "@/app/_services/GalleryService";
import EmailDialog from "./EmailDialog";
import Cookies from "js-cookie";

export default function Gallery(props: any) {
  const { showName, imageItems } = props;
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isLgDown = useMediaQuery(theme.breakpoints.down("lg"));
  const canHover = useMediaQuery("(hover: hover)");
  const [openDialog, setOpenDialog] = useState(false);
  const [hoveredId, setHoveredId] = useState<string>("");
  const [imageName, setImageName] = useState<string>("");

  const cols = isXs ? 1 : isLgDown ? 2 : 4;
  const gap = isXs ? 8 : isLgDown ? 10 : 12;
  const rowHeight = isXs ? 112 : isLgDown ? 140 : 180;

  const handleDownloadImage = (name: string) => {
    const loginCookie = Cookies.get("cuo-gallery");
    setImageName(name);
    if (loginCookie) {
      GalleryService.downloadImage(showName, name);
    } else {
      setOpenDialog(true);
    }
  };

  return (
    <>
      <ImageList
        className="image-list"
        variant="quilted"
        cols={cols}
        gap={gap}
        rowHeight={rowHeight}
        sx={{
          width: "100%",
          maxWidth: "100%",
          margin: 0,
          boxSizing: "border-box",
          height: "auto",
        }}
      >
        {imageItems?.map((image: any) => (
          <GalleryImage
            key={image.url}
            image={image}
            setHoveredId={setHoveredId}
            handleDownloadImage={handleDownloadImage}
            showDownloadBar={!canHover || hoveredId === image.url}
          />
        ))}
      </ImageList>
      <EmailDialog
        onConfirm={() => GalleryService.downloadImage(showName, imageName)}
        open={openDialog}
        onClose={() => setOpenDialog(false)}
      />
    </>
  );
}

const GalleryImage = ({
  image,
  setHoveredId,
  handleDownloadImage,
  showDownloadBar,
}: {
  image: any;
  setHoveredId: any;
  handleDownloadImage: any;
  showDownloadBar: boolean;
}) => {
  const [loading, setLoading] = useState(true);
  return (
    <ImageListItem
      onMouseLeave={() => setHoveredId("")}
      onMouseEnter={() => setHoveredId(image.url)}
      onClick={() => handleDownloadImage(image.name)}
      sx={{ position: "relative", overflow: "hidden", borderRadius: "8px" }}
    >
      <img
        srcSet={`${image.url}?w=248&fit=crop&auto=format&dpr=2 2x`}
        src={`${image.url}`}
        className="gallery-image"
        alt=""
        loading="lazy"
        style={{ display: loading ? "none" : "block" }}
        onLoad={() => setLoading(false)}
      />
      {loading && (
        <Skeleton
          variant="rectangular"
          animation="wave"
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            minHeight: 80,
            borderRadius: "8px",
          }}
        />
      )}
      {showDownloadBar && (
        <ImageListItemBar
          sx={{
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.45) 100%)",
          }}
          actionIcon={
            <IconButton
              sx={{ color: "white", p: { xs: 1.25, sm: 1 } }}
              aria-label="Download photo"
              size="medium"
            >
              <DownloadIcon />
            </IconButton>
          }
        />
      )}
    </ImageListItem>
  );
};
